export default __webpack_public_path__ + "static/media/moot-court-7.d0658505.webp";